import React from "react";

export default function SQL_LIKE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_LIKE</h1>
      <p>This is the SQL_LIKE component generated from the SQL JSON.</p>
    </div>
  );
}
